<template>
  <v-container
    fluid
    fill-height
    class="admin"
  >
    <v-layout
      align-center
      justify-center
      style="z-index: 10;"
    >
      <v-flex
        xs12
        sm8
        md6
      >
        <div
          style="margin:auto;text-align:center;margin: 20px;margin-bottom: 30px;"
        >
          <img
            :src="logo"
            style="vertical-align:middle;max-width: 100%;max-height: 100px;"
            @error="throwUnknownDomain()"
            alt="Firm Logo"
          />
        </div>
        <v-form
          ref="loginForm"
          @submit="submit"
        >
          <v-card-text v-if="!forgotPassword">
            <div
              style="font-weight: 300;text-align: center;font-size: 24px;margin-bottom: 35px;"
            >
              Log In to <span class="legalFoot" />
            </div>
            <v-alert
              :value="loginFailed"
              type="error"
            >
              Failed to log in. Check your username and password, then try again.
            </v-alert>
            <v-text-field
              v-model="username"
              key="username"
              :rules="[v => !!v || 'Username is required']"
              autofocus
              prepend-icon="person"
              name="login"
              label="Username"
              type="text"
              box
            />
            <v-text-field
              v-model="password"
              key="password"
              :rules="[v => !!v || 'Password is required']"
              id="password"
              prepend-icon="lock"
              name="password"
              label="Password"
              type="password"
              box
            />
          </v-card-text>
          <v-card-text v-if="forgotPassword">
            <span></span>
            <div
              style="font-weight: 300;text-align: center;font-size: 20px;margin-bottom: 5px;"
            >
              <b>Forgot your password?</b><br />
              <span
                style="font-size: 18px;"
              >
                Enter the e-mail associated with your account below to reset your password.
              </span>
            </div>
            <br />
            <v-text-field
              v-if="!postReset"
              v-model="email"
              key="email"
              :rules="[v => !!v || 'E-mail is required']"
              autofocus
              prepend-icon="mail"
              name="login"
              label="E-mail"
              type="text"
              box
            />
            <span
              v-else
              style="font-size:18px;"
            >
              If <code>{{email}}</code> matches a user account, we've sent you a new temporary password.
            </span>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="grey"
              flat
              @click="forgotPassword=!forgotPassword;postReset = false"
            >
              {{ forgotPassword ? 'Back to Log In' : 'Forgot Password?' }}
            </v-btn>
            <v-btn
              type="submit"
              color="primary"
              @click="forgotPassword ? resetPw() : login()"
            >
              {{ forgotPassword ? 'Reset Password' : 'Log In' }}
            </v-btn>
            <v-spacer/>
          </v-card-actions>
          <Preloader v-if="loading" />
        </v-form>
        <div
          style="text-align:center;padding: 10px;"
        >
          <v-btn
            href="/"
            depressed
            small
          >
            Are you a client? Click here to log in
          </v-btn>
        </div>
        <div
          v-if="getDomainInfo.app_name && getDomainInfo.app_name == 'CaseLocker'"
          style="display: flex;justify-content: center;align-items: center;margin: 35px;opacity: 0.4;margin-top: 50px;"
        >
          <img
            src="/assets/caselocker.png"
            style="max-height: 40px;margin-right: 10px"
          />
          <div
            style="font-weight: bold;font-size: 16px;"
          >
            Powered by CaseLocker
          </div>
        </div>
        <div
          v-else-if="getDomainInfo.app_name"
          style="display: flex;justify-content: center;align-items: center;margin: 35px;opacity: 0.4;margin-top: 50px;"
        >
          <div
            style="font-size: 16px;"
          >
            {{ getDomainInfo.app_name }}
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="wrong_organization"
      width="300"
    >
      <v-card>
        <v-card-text
          style="text-align:center;"
        >
          <div>
            <v-icon
              size="128"
            >
              mdi-routes
            </v-icon>
          </div>
          <div
            style="font-weight: 700;font-size: 18px;margin-bottom: 10px;"
          >
            Wrong Organization
          </div>
          You've attempted to log in with credentials for another {{ app_name }} organization. Make sure you're on the right domain and try again.
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Preloader from '@/components/global/Preloader'
import { mapGetters, mapMutations } from 'vuex'
import api from '@/api'

export default {
  name: 'Login',
  props: [ 'icon', 'logo' ],
  components: {
    Preloader
  },
  data () {
    return {
      username: '',
      password: '',
      loading: false,
      loginFailed: false,
      forgotPassword: false,
      email: '',
      postReset: false,
      wrong_organization: false
    }
  },
  watch: {
    loggedIn () {
      if (this.loggedIn) {
        this.$router.replace(this.$route.query.from || { name: 'AppHome' })
      }
    }
  },
  computed: {
    ...mapGetters('auth', [
      'loggedIn',
      'getDomainInfo'
    ]),
  },
  methods: {
    ...mapMutations('auth', [
      'setDomainInfo',
    ]),
    login: function () {
      if (this.$refs.loginForm.validate()) {
        this.loading = true
        this.$store.dispatch('auth/sessionLogIn', this)
          .then(() => {
            this.password = ''
            api.auth.organization.getInfo()
              .then((info) => {
                this.setDomainInfo(info)
              })
          }, (err) => {
            if ("wrong_organization" in err.response.data)
              this.wrong_organization = true
            this.loading = false
            this.loginFailed = true
            this.password = ''
          })
      }
    },
    resetPw: function () {
      if (this.$refs.loginForm.validate()) {
        this.loading = true
        this.$store.dispatch('auth/resetPw', { email: this.email })
          .then(() => {
            this.loading = false
            this.postReset = true
          }, () => {
            this.loading = false
            this.loginFailed = true
          })
      }
    },
    submit: function (e) {
      e.preventDefault()
    },
    throwUnknownDomain () {
      this.$router.push({ name: 'ErrorOrgNotFound' })
    }
  },
  created () {
    this.documentTitle('Log In')
    if (this.loggedIn) {
      this.$router.replace(this.$route.query.from || { name: 'AppHome' })
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.name === 'Login' && this.loggedIn) {
      this.$router.replace(to.query.from || { name: 'AppHome' })
    }
  }
}
</script>

<style>

  .background-marker {
    height: 100%;
    width: 100vw;
    position: fixed;
    top:-36px;
    left:0;
    z-index:0;
  }
</style>
